import { UPDATE_ASSESSMENT } from 'services/context/assessmentContext/assessmentContext';

export const updateAssessmentData = (assessment, dispatch) => {
  dispatch({
    type: UPDATE_ASSESSMENT,
    payload: { assessment }
  });
};
